<template>
  <vue-datepicker-local
    ref="input"
    :id="id"
    :name="name"
    :disabled="disabled"
    range-separator="-"
    inputClass="form-control"
    :local="local"
    :format="format"
    :value="value"
    @input="$emit('input', $event)"
    @blur="$emit('blur', $event), changeFocus()"
    @focus="changeFocus()"
  />
</template>

<script>
import VueDatepickerLocal from "vue-datepicker-local";

export default {
  inject: ["$validator"],
  name: "date-time-picker",
  props: {
    label: String,
    id: String,
    name: String,
    disabled: Boolean,
    placeholder: String,
    readonly: Boolean,
    required: String,
    value: [String, Array, Date],
    format: {
      type: String,
      default: "DD/MM/YYYY"
    }
  },
  components: {
    VueDatepickerLocal
  },
  data() {
    return {
      active: false,
      local: {
        dow: 0, // Sunday is the first day of the week
        hourTip: "Selecione a Hora", // tip of select hour
        minuteTip: "Selecione o Minuto", // tip of select minute
        secondTip: "Selecione o Segundo", // tip of select second
        yearSuffix: "", // suffix of head year
        monthsHead: [
          "Janeiro",
          "Fevereiro",
          "Março",
          "Abril",
          "Maio",
          "Junho",
          "Julho",
          "Agosto",
          "Setembro",
          "Outubro",
          "Novembro",
          "Dezembro"
        ], // months of head
        months: [
          "Jan",
          "Fev",
          "Mar",
          "Abr",
          "Mai",
          "Jun",
          "Jul",
          "Ago",
          "Set",
          "Out",
          "Nov",
          "Dez"
        ], // months of panel
        weeks: ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sáb"], // weeks,
        cancelTip: "Cancelar",
        submitTip: "Confirmar"
      }
    };
  },
  methods: {
    changeFocus() {
      this.active = !this.active;
    }
  },
  mounted() {
    this.$el.value = this.value;
  }
};
</script>

<style>
.datepicker {
  display: block !important;
}

.datepicker-range .datepicker-popup {
  min-width: 403px;
  width: max-content !important;
}

.datepicker.datepicker-range {
  min-width: auto;
}

.datepicker > input.form-control {
  height: 40px !important;
  cursor: pointer;
  border: 1px solid #ccc;
}
</style>



// WEBPACK FOOTER //
// src/components/UIComponents/Forms/DateTimePicker.vue